import { render } from "./SvgXMark.vue?vue&type=template&id=9dbbf76a&scoped=true&ts=true"
import script from "./SvgXMark.vue?vue&type=script&lang=ts"
export * from "./SvgXMark.vue?vue&type=script&lang=ts"

import "./SvgXMark.vue?vue&type=style&index=0&id=9dbbf76a&scoped=true&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dbbf76a"]])

export default __exports__